
import KPICards from './KPICards';

import ParameterComparison from './ParameterComparison';
import ScatterChart from './ScatterChart';
import EnergyEfficiencyTrends from './EnergyEfficiencyTrends';
import Filter_MS_Growth from './Filter/Filter_MS_Growth';
import Filter_growth from './Filter/Filter_growth';
import { decodeToken } from 'react-jwt';
import { API_URL_MAIN, INIT_FILTER_STATE_MILEAGE_SAARATHI } from '../../../../constants/driveglobalfilterinitalstates_bus';
import * as $ from 'jquery';
import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';

import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import DownloadReport from './Downloadreport';
import moment from 'moment';

// Inside GrowthTrackingTab
// const n = moment("2024-08-01");
const INIT_FILTER_STATE_MILEAGE_SAARATHI_OVERVIEW = {
  startDate: moment().subtract(7, 'days').format("YYYY-MM-DD"), // moment(new Date("2024-01-01T00:00:00.000Z")).toDate(),
  endDate: moment().subtract(1, 'days').format("YYYY-MM-DD"),// moment(new Date("2025-01-20T00:00:00.000Z")).toDate(),
  VIN_NUM: [],
  CITY: [],
  DEPO: [],
  ROUTE: []
};



const GrowthTrackingTab = () => {
  const [selectedParameter, setSelectedParameter] = useState('');
  const [showScatterChart, setShowScatterChart] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState();
  const [reportData, setReportData] = useState({});
  // const [filterData, setFilterData] = useState(getDateRange(moment()));
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE_MILEAGE_SAARATHI_OVERVIEW, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE_MILEAGE_SAARATHI_OVERVIEW
  const [globalFilter, setGlobalFilter] = useState({ ...sampleObj })



  const insightsRef = useRef();
  // Handle view graph click from ParameterComparison
  const handleViewGraph = (parameterTitle) => {
    setSelectedParameter(parameterTitle);
    setShowScatterChart(true);

    // Scroll to scatter chart section after a short delay to ensure it's rendered
    setTimeout(() => {
      const scatterChartElement = document.getElementById('scatter-chart-section');
      if (scatterChartElement) {
        scatterChartElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  };
  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  }
  const filterSubmitted = useCallback((data) => {
    setGlobalFilter(data);
  }, []);

  // Handle parameter change from ScatterChart dropdown
  const handleParameterChange = (parameterTitle) => {
    setSelectedParameter(parameterTitle);
  };

  // Reset scatter chart visibility when component unmounts or page changes
  useEffect(() => {
    return () => {
      setShowScatterChart(false);
      setSelectedParameter('');
    };
  }, []);

  // Handle page visibility change to reset state when user leaves/returns
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Page is hidden (user navigated away)
        setShowScatterChart(false);
        setSelectedParameter('');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);





  return (
    <>
      <div className="mb-4">
        <Filter_growth onsubmit={filterSubmitted} setGlobalFilter={setGlobalFilter} gloablfilter={{ ...globalFilter }} setGloablfilter={setGlobalFilter} />
      </div>
      <div >

      </div>
      <div className="mb-4">
        <KPICards filterdata={globalFilter} setGloablfilter={setGlobalFilter} />
      </div>
      <div className="mb-4">
        {/* <VehicleSelection /> */}
        <Filter_MS_Growth filterdata={globalFilter} setGloablfilter={setGlobalFilter} />

      </div>
      <div className="mb-4">
        <ParameterComparison onViewGraph={handleViewGraph} filterdata={globalFilter} setGloablfilter={setGlobalFilter} />
      </div>
      <div className="mb-4">
        <ScatterChart
          selectedParameter={selectedParameter}
          isVisible={showScatterChart}
          onParameterChange={handleParameterChange}
          filterdata={globalFilter} />
      </div>
      <div className="mb-4">
        <EnergyEfficiencyTrends
          filterdata={globalFilter} />
      </div>
    </>
  );
};

export default GrowthTrackingTab;
